import { initContract } from "@ts-rest/core";
import { z } from "zod";
import {
    BillingHistoryDtoSchema,
    BillingInfoDtoSchema,
} from "@common/schemas/billing.schema";
import { ErrorMessageSchema } from "@common/schemas/error.schema";

const c = initContract();

export const billingContract = c.router(
    {
        getBillingHistory: {
            path: "/billing-history",
            method: "GET",
            responses: {
                200: BillingHistoryDtoSchema,
                401: ErrorMessageSchema,
            },
        },
        getBillingInfo: {
            path: "/billing-info",
            method: "GET",
            responses: {
                200: BillingInfoDtoSchema.nullable(),
                401: ErrorMessageSchema,
            },
        },
        getBillingInfoForWorkspace: {
            path: "/billing-info/:workspaceId",
            method: "GET",
            pathParams: z.object({ workspaceId: z.string().uuid() }),
            responses: {
                200: BillingInfoDtoSchema.nullable(),
                401: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/billing",
    },
);
